import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M8.029 2.25c.273.011.52.17.642.415l1.808 3.615a3.75 3.75 0 0 1 2.65 5.788l2.401 2.402a.75.75 0 1 1-1.06 1.06l-2.402-2.401a3.75 3.75 0 1 1-3.195-6.706L7.94 4.556l-2.297 3.83a.75.75 0 0 1-1.355-.149L3.912 7.11 1.69 12.295a.75.75 0 1 1-1.378-.59l3-7a.75.75 0 0 1 1.4.058l.485 1.453 2.16-3.602a.75.75 0 0 1 .673-.363ZM10 7.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n
];
function c(r, d) {
  return e(), t("svg", o, [...a]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
